<template lang="pug">
.event-index
  div(v-if="isLogged", style="width: 100%; height: 100%; position: relative")
    .event-index-content
      router-view
    EventIndexFooter
  //- SubscribeVip(v-if="isLogged")
  notSubscribe(v-else)
</template>
<script>
import SubscribeVip from './SubscribeVip'
import NotSubscribe from './NotSubscribe'
import HomePage from './HomePage/HomePage'
import EventIndexFooter from './EventIndexFooter.vue'
import store from '../store'
export default {
  name: 'EventIndex',
  beforeRouteEnter (to, from, next) {
    // 已经登陆时请求用户信息
    // console.log(store.getters.logged)
    if (store.getters.logged) {
      store.dispatch('GetUserinfo')
        .then(res => {
          next()
        })
    } else {
      next()
    }
  },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {
    isVip () {
      return this.$store.getters.isVip
    },
    isLogged () {
      return this.$store.getters.logged
    }
  },
  methods: {
  },
  components: {
    SubscribeVip,
    NotSubscribe,
    HomePage,
    EventIndexFooter
  }
}
</script>
<style lang="scss" scoped>
.event-index {
  background-color: #f8f9fe;
  color: #333;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.float_ball {
  position: fixed;
  right: 10px;
  bottom: 80px;
  z-index: 9999999999999;
}
.event-index-content {
  width: 1240px;
  margin: 0 auto;
  min-height: calc(100% - 370px);
  // overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/EventIndex.vue